import React, { useState, useContext } from "react";

import MenuItem from "@material-ui/core/MenuItem";
import Divider from "@material-ui/core/Divider";

import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import ConfirmationModal from "../ConfirmationModal";
import { Menu } from "@material-ui/core";
import { ReplyMessageContext } from "../../context/ReplyingMessage/ReplyingMessageContext";
import toastError from "../../errors/toastError";

const MessageOptionsMenu = ({
  message,
  menuOpen,
  handleClose,
  anchorEl,
  onSuggestReply,
  onTranslateMessage,
  onHideTranslation,
  hasTranslation,
  isAiActionLoading
}) => {
  const { setReplyingMessage } = useContext(ReplyMessageContext);
  const [confirmationOpen, setConfirmationOpen] = useState(false);

  const handleDeleteMessage = async () => {
    try {
      await api.delete(`/messages/${message.id}`);
    } catch (err) {
      toastError(err);
    }
  };

  const hanldeReplyMessage = () => {
    setReplyingMessage(message);
    handleClose();
  };

  const handleOpenConfirmationModal = (e) => {
    setConfirmationOpen(true);
    handleClose();
  };

  const handleSuggestReply = () => {
    if (onSuggestReply) {
      onSuggestReply(message);
    }
    handleClose();
  };

  const handleTranslateToPortuguese = () => {
    if (onTranslateMessage) {
      onTranslateMessage(message, "Brazilian Portuguese (pt-BR)");
    }
    handleClose();
  };

  const handleTranslateToEnglish = () => {
    if (onTranslateMessage) {
      onTranslateMessage(message, "English");
    }
    handleClose();
  };

  const handleHideTranslation = () => {
    if (onHideTranslation) {
      onHideTranslation(message);
    }
    handleClose();
  };

  return (
    <>
      <ConfirmationModal
        title={i18n.t("messageOptionsMenu.confirmationModal.title")}
        open={confirmationOpen}
        onClose={setConfirmationOpen}
        onConfirm={handleDeleteMessage}
      >
        {i18n.t("messageOptionsMenu.confirmationModal.message")}
      </ConfirmationModal>
      <Menu
        anchorEl={anchorEl}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={menuOpen}
        onClose={handleClose}
      >
        {message.fromMe && (
          <MenuItem onClick={handleOpenConfirmationModal}>
            {i18n.t("messageOptionsMenu.delete")}
          </MenuItem>
        )}
        <MenuItem onClick={hanldeReplyMessage}>
          {i18n.t("messageOptionsMenu.reply")}
        </MenuItem>
        {!message.fromMe && <Divider />}
        {!message.fromMe && (
          <MenuItem onClick={handleSuggestReply} disabled={isAiActionLoading}>
            {i18n.t("messageOptionsMenu.suggestReply")}
          </MenuItem>
        )}
        {!message.fromMe && (
          <MenuItem
            onClick={handleTranslateToPortuguese}
            disabled={isAiActionLoading}
          >
            {i18n.t("messageOptionsMenu.translateToPortuguese")}
          </MenuItem>
        )}
        {!message.fromMe && (
          <MenuItem onClick={handleTranslateToEnglish} disabled={isAiActionLoading}>
            {i18n.t("messageOptionsMenu.translateToEnglish")}
          </MenuItem>
        )}
        {!message.fromMe && hasTranslation && (
          <MenuItem onClick={handleHideTranslation} disabled={isAiActionLoading}>
            {i18n.t("messageOptionsMenu.hideTranslation")}
          </MenuItem>
        )}
      </Menu>
    </>
  );
};

export default MessageOptionsMenu;
